// A join that never reaches media. The call server gives a client 10 s to send its SDP offer after the
// join (rtcd `signalingTimeout`) and then drops the session — while the app kept showing «Uniéndose…»
// until the call socket closed a minute later (carlos.sc, Windows 1.0.43, 2026-11-03: the first call
// connected, the next two joins never sent an offer). So: a join still not connected after
// `stallMillis` is retried ONCE on fresh transport (new socket, new peer connection); a second stall
// ends it as «La llamada falló» and the call's own log goes to Core (reason `call`, shared/API.md §45).
// Twins: Kotlin calls/CallJoinWatchdog.kt, Swift Calls/CallJoinWatchdog.swift, C# Logic/CallJoinWatchdog.cs.

export type JoinStallAction = 'retry' | 'fail';

export const CallJoinWatchdog = {
  /** Normal joins connect in under a second; TURN over TCP in a few. */
  stallMillis: 12_000,
  /** The first attempt plus one retry. */
  maxAttempts: 2,

  decide(attempt: number): JoinStallAction {
    return attempt < CallJoinWatchdog.maxAttempts ? 'retry' : 'fail';
  },

  /** The report's one-line description: what failed, after how many tries. */
  describe(attempts: number, stage: string): string {
    return `call join stalled: no media after ${attempts} attempt(s) of ${CallJoinWatchdog.stallMillis / 1000} s (last stage: ${stage})`;
  },
} as const;
